module.exports = __webpack_public_path__ + "img/CharacterSheetPage4.0bbb6edf.png";